import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { GET_POLICY_LIST } from "../../../../../common/constant";
import { UPDATE_POLICY, SHARE_POLICY, SOURCE_FOR_ENQUIRY } from "../../../../../common/constant";
import { get, post } from "../../../../../common/api";
import Api from "../../../../../common/api/multipart";

export const actionGetPolicyList = createAsyncThunk(
  "policyStore/actionGetPolicyList",
  async (params, thunkAPI) => {
    return await post(GET_POLICY_LIST, params, thunkAPI);
  }
);

export const actionPolicyUpdate = createAsyncThunk(
  "policyStore/actionPolicyUpdate",
  async (params, thunkAPI) => {
    // const id = params.id;
    // delete params.id;
    return await Api.multipart(UPDATE_POLICY, params, thunkAPI);
  }
);


export const actionSharePolicy = createAsyncThunk(
  "policyStore/actionSharePolicy",
  async (params, thunkAPI) => {
    return await post(SHARE_POLICY, params, thunkAPI);
  }
);

export const actionSourceForEnquiry = createAsyncThunk(
  'policyStore/actionSourceForEnquiry',
  async (params, thunkAPI) => {
    return await post(SOURCE_FOR_ENQUIRY, params, thunkAPI);
  }
)

export const policySlice = createSlice({
  name: "policyStore",

  initialState: {
    // source for enquiry
    loadingSourceForEnquiry: false,
    getSource: null,

    //get policy
    loadingGetPolicyList: false,
    getPolicyList: null,

    // update policy
    loadingUpdatePolicy: false,
    updatePolicy: null,

    // share Policy
    loadingSharePolicy: false,
    sharePolicy: null,
  },
  reducers: {
    //reset or delete public store data
    resetGetSource: (state) => {
      state.getSource = null;
    },

    resetGetPolicyList: (state) => {
      state.getPolicyList = null;
    },

    resetUpdatePolicy: (state) => {
      state.updatePolicy = null;
    },

    resetSharePolicy: (state) => {
      state.sharePolicy = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(actionSourceForEnquiry.pending, (state) => {
        state.loadingSourceForEnquiry = true;
      })
      .addCase(actionSourceForEnquiry.fulfilled, (state, action) => {
        state.loadingSourceForEnquiry = true;
        state.getSource = action.payload;
      })
      .addCase(actionSourceForEnquiry.rejected, (state) => {
        state.loadingSourceForEnquiry = false;
      })

      .addCase(actionGetPolicyList.pending, (state) => {
        state.loadingGetPolicyList = true;
      })
      .addCase(actionGetPolicyList.fulfilled, (state, action) => {
        state.loadingGetPolicyList = true;
        state.getPolicyList = action.payload;
      })
      .addCase(actionGetPolicyList.rejected, (state) => {
        state.loadingGetPolicyList = false;
      })

      .addCase(actionPolicyUpdate.pending, (state) => {
        state.loadingUpdatePolicy = true;
      })
      .addCase(actionPolicyUpdate.fulfilled, (state, action) => {
        state.loadingUpdatePolicy = false;
        state.updatePolicy = action.payload;
      })
      .addCase(actionPolicyUpdate.rejected, (state) => {
        state.loadingUpdatePolicy = false;
      })

      .addCase(actionSharePolicy.pending, (state) => {
        state.loadingSharePolicy = false;
      })

      .addCase(actionSharePolicy.fulfilled, (state, action) => {
        state.loadingSharePolicy = false;
        state.sharePolicy = action.payload;
      })

      .addCase(actionSharePolicy.rejected, (state) => {
        state.loadingSharePolicy = false;
      })
  },
});

export const { resetGetPolicyList, resetUpdatePolicy, resetSharePolicy, resetGetSource } = policySlice.actions;

export default policySlice.reducer;
